import { Button, List, Tooltip } from "antd";
import { DownloadIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
import Input from "antd/es/input/Input";
import { WODetailType } from "../../../ducks/types";
import EmptyCard from "../../../../../atoms/EmptyCard";

type PropsType = {
  woDetailData: WODetailType | null;
};

export default function Equipment(props: PropsType) {
  const { woDetailData } = props;

  return (
    <div className="equipmentList no_shadow">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h3> Equipment </h3>

        {(woDetailData?.subServices && woDetailData.subServices.length > 0
          ? woDetailData.subServices.flatMap((s) => s.equipments)
          : woDetailData?.equipments || []
        ).length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div className="filterSearch">
              <Input prefix={<SearchIcon />} placeholder="Search" allowClear />
            </div>
            <div className="filterDownload">
              <Tooltip title="Export the list of equipment">
                <Button
                  icon={<DownloadIcon />}
                  style={{ height: "36px", width: "36px" }}
                  disabled={true}
                />
              </Tooltip>
            </div>
          </div>
        )}
      </div>
      <List
        header={
          ((woDetailData?.subServices && woDetailData.subServices.length > 0
            ? woDetailData.subServices.flatMap((s) => s.equipments)
            : woDetailData?.equipments || []
          ).length > 0 && <div>Name</div>) ||
          null
        }
        bordered
        dataSource={
          woDetailData?.subServices && woDetailData?.subServices?.length > 0
            ? woDetailData?.subServices?.flatMap(
                (subService) => subService.equipments
              )
            : woDetailData?.equipments || []
        }
        renderItem={(item) => <List.Item>{item}</List.Item>}
        locale={{
          emptyText: (
            <div className="empty_wrap">
              <EmptyCard
                imageHeight={180}
                title="There are no equipments"
                description=""
                image="/images/empty-icons/no-active.svg"
              />
            </div>
          ),
        }}
      />
    </div>
  );
}
